var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive illustration"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 146,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 23.8967,
    y: 41,
    width: 104,
    height: 76,
    rx: 4,
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1_2",
    x: 49.6353,
    y: 29.1289,
    width: 61.9998,
    height: 76.903,
    rx: 3.5,
    fill: "white",
    stroke: "#6D6D70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1_3",
    x: 41.9644,
    y: 36.7998,
    width: 61.9998,
    height: 76.903,
    rx: 3.5,
    fill: "white",
    stroke: "#6D6D70"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 24",
    d: "M118.897 46V10",
    stroke: "#98CB65",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 25",
    d: "M118.897 62L118.897 52",
    stroke: "#98CB65",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 26",
    d: "M19 115.199L19 79.0368",
    stroke: "#6D6D70",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 27",
    d: "M19 130.541L19 120.678",
    stroke: "#6D6D70",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1_4",
    d: "M33.7935 50.1621C33.7935 47.953 35.5843 46.1621 37.7935 46.1621L92.7933 46.1621C95.0024 46.1621 96.7933 47.953 96.7933 50.1621V120.065C96.7933 122.274 95.0024 124.065 92.7933 124.065L37.7935 124.065C35.5843 124.065 33.7935 122.274 33.7935 120.065V83.4201V77.1191L33.7935 70.8181V50.1621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5",
    d: "M33.7935 56.0245V50.1621C33.7935 47.953 35.5843 46.1621 37.7935 46.1621L92.7933 46.1621C95.0024 46.1621 96.7933 47.953 96.7933 50.1621V120.065C96.7933 122.274 95.0024 124.065 92.7933 124.065L37.7935 124.065C35.5843 124.065 33.7935 122.274 33.7935 120.065L33.7935 73.5577M33.7935 62.0515V70.8181",
    stroke: "#6D6D70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 40.3684,
    y: 61.5037,
    width: 51.5037,
    height: 10.9582,
    rx: 2,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 40.3684,
    y: 79.0369,
    width: 51.5037,
    height: 9.8624,
    rx: 2,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 40.3684,
    y: 95.4741,
    width: 51.5037,
    height: 10.9582,
    rx: 2,
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line 25_2",
    x1: 56.8057,
    y1: 75.2493,
    x2: 92.9678,
    y2: 75.2493,
    stroke: "#6D6D70"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 27_2",
    y1: -0.5,
    x2: 36.1621,
    y2: -0.5,
    transform: "matrix(-1 0 0 1 74.3389 93.2825)",
    stroke: "#6D6D70"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 26_2",
    x1: 45.8474,
    y1: 75.2493,
    x2: 53.5182,
    y2: 75.2493,
    stroke: "#6D6D70"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 28",
    y1: -0.5,
    x2: 7.67076,
    y2: -0.5,
    transform: "matrix(-1 0 0 1 85.2971 93.2825)",
    stroke: "#6D6D70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 71_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1_5",
    d: "M112.741 82.4613C112.741 82.4348 112.719 82.4133 112.693 82.4133L112.435 82.4133L102.225 100.282C101.423 101.684 99.9323 102.549 98.3175 102.549L31.2187 102.549C29.2857 102.549 27.7187 104.116 27.7187 106.049V131.795C27.7187 133.728 29.2857 135.295 31.2187 135.295L98.2012 135.295C99.5111 135.295 100.711 134.564 101.312 133.4L112.351 111.997C112.607 111.501 112.741 110.951 112.741 110.393V82.4613Z",
    fill: "white",
    stroke: "#6D6D70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2_2",
    x: 34.8894,
    y: 110.816,
    width: 56.9828,
    height: 18.629,
    rx: 2,
    fill: "#C5E9B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3_2",
    d: "M102.83 108.325C102.83 107.085 103.159 105.868 103.784 104.798L109.569 94.88C109.826 94.4392 110.501 94.6216 110.501 95.1319V106.191C110.501 107.784 110.078 109.349 109.275 110.726L104.694 118.579C104.18 119.46 102.83 119.096 102.83 118.075V108.325Z",
    fill: "#F0F0F0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIllustration);
export default __webpack_public_path__ + "static/media/archive-illustration.090fa45d61b383ff15ca1f0472ba48de.svg";
export { ForwardRef as ReactComponent };